export const HeadingMarginStyle = {
  marginLeft: "40px",
  marginRight: "40px",
  marginTop: "30px",
};
export const ParagraphMarginStyle = {
  marginLeft: "40px",
  marginRight: "40px",
  marginTop: "5px",
};
